<i [ngClass]="{'fas': fas, 'far': far, 'fab': fab, 'fal': fal}" class="fa-{{icon}} {{class}} {{classInside}} {{sizeClass}}"></i>
